import { server } from '../../core/engine/server'
import { modal } from '../../core/utilities/modal'

var GeneratePDF = Class.create({
  	initialize: function() {},
	generateWorkOrderPDF: function(workOrderID, callback) {
		var self = this;
		var url = "maintenance/order/generate/" + workOrderID;
		var data = server.getFile(url, null, true, function(success){
            if(success) {
                callback();
            } else {
                modal.showInfo("Oops! Failed to download pdf.", "danger", "top", "center");
            }
        });
    },
    generateTenantHistoryPDF: function(callback) {
		var self = this;
		var url = "reports/tenants/history";
		var data = server.getFile(url,null,true, function(success){
            if(success) {
                callback();
            } else {
                modal.showInfo("Oops! Failed to download pdf.", "danger", "top", "center");
            }
        });
    },
    generateTenantInvoicePDF: function(invoice, callback) {
		var self = this;
		var url = "reports/tenants/invoice/" + invoice.tenant_payment_history_id;
		var data = server.getFile(url,null,true, function(success){
            if(success) {
                callback();
            } else {
                modal.showInfo("Oops! Failed to download pdf.", "danger", "top", "center");
            }
        });
    }
});

export let generatePDF = new GeneratePDF();


// WEBPACK FOOTER //
// app/helpers/General/GeneratePDF.js